<template>
  <section id="main">
    <div class="block w-100">
      <h1 class="mx-auto align-center"><strong>Our games</strong></h1>
    </div>

    <div class="games-grid">
      <div class="game-container">
        <a
          href="https://crystalblast.page.link/install"
          class="p-1 pb-0 box flex flex-wrap flex-column"
        >
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/crystal-blast.png')"
            />
            <h3>Crystal Blast</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://apps.apple.com/us/app/crystal-blast/id1451868968"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.balconygames.CrystalBlast"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>

              <a
                href="https://www.amazon.com/-/es/dp/B07W1JL921"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'amazon']" class="fa-2x" />
              </a>
            </div>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a
          href="https://sweetyjumper.page.link/install"
          class="p-1 pb-0 box flex flex-wrap flex-column"
        >
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/sweety-jumper.png')"
            />
            <h3>Sweety Jumper</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://apps.apple.com/es/app/dont-fall-by-balcony-games/id1460842492"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.balconygames.sweetyjumper"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>
            </div>
          </div>
        </a>
      </div>
      <div class="game-container">
        <a
          href="https://snakeio.page.link/install"
          class="p-1 pb-0 box flex flex-wrap flex-column"
        >
          <div class="block">
            <v-lazy-image :src="require('../assets/images/games/snake.png')" />
            <h3>Snake</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://apps.apple.com/by/app/snake-by-balcony-games/id1460842595"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.balconygames.snake"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>
            </div>
          </div>
        </a>
      </div>
      <div class="game-container">
        <a
          href="https://dontfall.page.link/install"
          class="p-1 pb-0 box flex flex-wrap flex-column"
        >
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/dontfall.png')"
            />
            <h3>Don't Fall</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://apps.apple.com/es/app/dont-fall-by-balcony-games/id1460842492"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.balconygames.dontfall"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>
            </div>
          </div>
        </a>
      </div>
      <div class="game-container">
        <a
          href="https://bbcrystals.page.link/install"
          class="p-1 pb-0 box flex flex-wrap flex-column"
        >
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/BricksBreaker.png')"
            />

            <h3>Bricks Breaker</h3>
          </div>

          <div class="max-w-sm mx-auto self-end mt-auto">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://apps.apple.com/es/app/dont-fall-by-balcony-games/id1460842492"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.balconygames.BricksBreaker"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>
            </div>
          </div>
        </a>
      </div>

      <div class="game-container">
        <!--  https://diceblast.page.link/install -->
        <a
          href="https://dice-blast-web.web.app/"
          class="p-1 pb-0 box flex flex-wrap flex-column"
        >
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/DiceBlast.png')"
            />
            <h3>Upcoming: Dice Blast</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="#"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a href="#" target="_blank" class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center">
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>
            </div>
          </div>
        </a>
      </div>

      <div class="game-container">
        <!-- https://paintswipe.page.link/install -->
        <a href="#" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/PaintSwipe.png')"
            />
            <h3>Upcoming: Paint Swipe</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="#"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a href="#" target="_blank" class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center">
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>
            </div>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="#" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/Question.png')"
            />
            <h3>Prototypes in progress...</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="#"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a href="#" target="_blank" class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center">
                <font-awesome-icon
                  :icon="['fab', 'google-play']"
                  class="fa-2x"
                />
              </a>
            </div>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="#" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image
              :src="require('../assets/images/games/html5-games.png')"
            />
            <h3>HTML5 Games</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://balcony.games"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fas', 'globe']" class="fa-2x" />
              </a>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="block w-100 mt-12">
      <h1 class="mx-auto align-center"><strong>Our apps</strong></h1>
    </div>

    <div class="games-grid">
      <div class="game-container">
        <a href="https://pushup.bitscorp.co/" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/apps/pushup.png')" />
            <h3>PushUP Challenges</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://apps.apple.com/us/app/pushup-challenges/id6450053262"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=co.bitscorp.pushup"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'google-play']" class="fa-2x" />
              </a>
            </div>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="https://palm.bitscorp.co/" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/apps/palm.png')" />
            <h3>Palm Reader AI</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <!-- <a
                href="https://apps.apple.com/us/app/palm-reader-ai/id1234567890"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a> -->

              <a
                href="https://play.google.com/store/apps/details?id=co.bitscorp.palm"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'google-play']" class="fa-2x" />
              </a>
            </div>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="#" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/apps/catalan.png')" />
            <h3>Catalan Verbs</h3>
          </div>

          <div class="max-w-sm mx-auto self-end">
            <div class="sm:flex sm:items-center justify-center gap-4">
              <a
                href="https://apps.apple.com/es/app/catalan-verbs/id6738144158"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'app-store']" class="fa-2x" />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=co.bitscorp.cat"
                target="_blank"
                class="w-12 h-12 mx-auto sm:mt-0 flex items-center justify-center"
              >
                <font-awesome-icon :icon="['fab', 'google-play']" class="fa-2x" />
              </a>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="block w-100 mt-12">
      <h1 class="mx-auto align-center"><strong>Our Chrome Extensions</strong></h1>
    </div>

    <div class="games-grid">
      <div class="game-container">
        <a href="https://chromewebstore.google.com/detail/dots-game/pohbllgenaajfpjkncldjkifdelobdfn?authuser=0&hl=en" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/extensions/dots-game.png')" />
            <h3>Dots Game</h3>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="https://chromewebstore.google.com/detail/learn-basque/goplofbdpdkeopimioaecokgpfcaooom?authuser=0&hl=en" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/extensions/learn-basque.png')" />
            <h3>Learn Basque</h3>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="https://chromewebstore.google.com/detail/tetrominus/eeehcmbhicglclggakomjhhlmemhjbde?authuser=0&hl=en" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/extensions/tetrominus.png')" />
            <h3>Tetrominus</h3>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="https://chromewebstore.google.com/detail/learn-french/jajgjaibgcfdidjidojidenpfcfjeaoj?authuser=0&hl=en" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/extensions/learn-french.png')" />
            <h3>Learn French</h3>
          </div>
        </a>
      </div>

      <div class="game-container">
        <a href="https://chromewebstore.google.com/detail/learn-spanish/onnolcnjhjbmcgfppkmamfkadklopbkj?authuser=0&hl=en" class="p-1 pb-0 box flex flex-wrap flex-column">
          <div class="block">
            <v-lazy-image :src="require('../assets/images/extensions/learn-spanish.png')" />
            <h3>Learn Spanish</h3>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
.v-lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
  @apply rounded-lg;
  width: 100%;
  height: auto;
}

.v-lazy-image-loaded {
  filter: blur(0);
}

.game-container {
  width: 100%;
  min-width: auto;
  padding: 0.5rem;
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  padding: 1rem;
}

.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.box h3 {
  text-align: center;
  margin: 1rem 0;
  font-size: 1.5rem;
}

.max-w-sm {
  margin-top: 1rem;
}

.block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Update main title styles */
h1 {
  font-size: 2.5rem;
}

.fa-2x {
  display: block;
  margin: auto;
}

@media (max-width: 768px) {
  .games-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .game-container {
    padding: 0.5rem;
  }

  .box {
    width: 90%;
    margin: 0 auto;
  }

  h1 {
    font-size: 2rem;
  }

  .sm\:flex {
    display: flex !important;
  }

  .sm\:items-center {
    align-items: center !important;
  }

  .max-w-sm {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .games-grid {
    gap: 0.5rem;
    padding: 0.5rem;
    grid-template-columns: 1fr;
    width: 100%;
  }

  .box {
    width: 100%;
    margin: 0 auto;
  }

  h1 {
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  .game-container {
    padding: 0.25rem;
    max-width: 100%;
  }

  .sm\:flex {
    justify-content: center;
    gap: 1rem;
  }

  .w-12 {
    width: 2.5rem;
  }

  .h-12 {
    height: 2.5rem;
  }
}
</style>

<script>
import VLazyImage from "v-lazy-image";

export default {
  name: "Home",
  components: {
    VLazyImage,
  },
};
</script>
